// import { Link } from 'react-router-dom';
// import GraphicStand from 'components/graphic-stand';
// import GraphicPacking from 'components/graphic-packing';

const GraphicStandTitleField = ({ id, title, graphicListId }) => {
    return (
        // <Link to={{
        //     pathname: `${GraphicPacking.Const.basePath}/${graphicListId}${GraphicStand.Const.basePath}/${id}`,
        //     state: {
        //         breadcrumbSlug: {
        //             id,
        //             label: title
        //         }
        //     }
        // }}
        // >
        //     {title}
        // </Link>
        <strong style={ { color: 'white' } }>
            {title}
        </strong>
    );
};

export default GraphicStandTitleField;
